module.exports = __webpack_public_path__ + "assets/img/team/eckhard-kahle.jpg";